import axios from 'axios'
import config from '../config'

const SEND_REQUEST = 'SEND_REQUEST'
const RECEIVE_HALLS = 'RECEIVE_HALLS'
const RECEIVE_BOOTHS = 'RECEIVE_BOOTHS'
const RECEIVE_BOOTH = 'RECEIVE_BOOTH'

const initialState = {
  halls: [],
  booths: [],
  viewBooth: null,
  userScore: null,
  boothQuizAnswers: [],
}

export default function boothReducer(state = initialState, action) {
  switch (action.type) {
    case SEND_REQUEST:
      return {
        ...state,
        apiLoading: true,
        viewBooth: null,
      }
    case RECEIVE_HALLS:
      return {
        ...state,
        halls: action.halls,
      }

    case RECEIVE_BOOTHS:
      return {
        ...state,
        apiLoading: false,
        booths: action.booths,
      }

    case RECEIVE_BOOTH:
      return {
        ...state,
        viewBooth: action.viewBooth,
      }
   
    default:
      return state
  }
}

export function getHalls() {
  return (dispatch) => {
    dispatch(requestData())

    return axios
      .get(`${config.apiUrl}/api/exhibition_halls`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          dispatch(receiveHalls(data.halls))
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}

export function getBooths(hallId) {
  return (dispatch) => {
    return axios
      .get(`${config.apiUrl}/api/exhibition_halls/${hallId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          dispatch(receiveBooths(data.hall.booths))
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}

export function getBooth(boothId) {
  return (dispatch) => {
    dispatch(requestData())

    return axios
      .get(`${config.apiUrl}/api/booths/${boothId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
        },
      })
      .then(({ status, data }) => {
        if (status === 200 && data.success) {
          dispatch(
            receiveBooth({
              ...data.booth,
            })
          )
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
      })
  }
}

function requestData() {
  return {
    type: SEND_REQUEST,
  }
}

function receiveHalls(halls) {
  return {
    type: RECEIVE_HALLS,
    halls,
  }
}

function receiveBooths(booths) {
  return {
    type: RECEIVE_BOOTHS,
    booths,
  }
}

function receiveBooth(viewBooth) {
  return {
    type: RECEIVE_BOOTH,
    viewBooth,
  }
}
